import { useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useArtworkForm } from "@design-lab/entities/artwork";
import initSignInModalOriginal from "components/jiffy/sign-in-modal/sign-in-modal";

const INITIALIZED_ATTR = "data-sign-in-modal-initialized";

function initSignInModal(uuid: string | undefined) {
  if (!uuid) return null;

  const modalElement = document.querySelector(".js-sign-in-modal");
  if (!modalElement) return null;

  if (modalElement.hasAttribute(INITIALIZED_ATTR)) {
    return null;
  }

  const signInModal = initSignInModalOriginal(uuid);
  modalElement.setAttribute(INITIALIZED_ATTR, "true");

  return signInModal;
}

export function useSignInModalInit() {
  const { form: artworkForm } = useArtworkForm();

  const designProjectUuid = useWatch({
    control: artworkForm.control,
    name: "designProjectUuid"
  });

  useEffect(() => {
    initSignInModal(designProjectUuid);
  }, [designProjectUuid]);
}
